import { CloudUpload as UploadIcon } from '@mui/icons-material';
import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import ImageCardGlyph from './ImageCardGlyph';

/** The "New slide" tile's body: an upload spinner while adding, otherwise the glyph + hint text. */
export default function AddSlideCardContent({ adding }: { adding: boolean }) {
  if (adding) {
    return (
      <>
        <CircularProgress size={24} />
        <Typography variant="caption">Uploading…</Typography>
      </>
    );
  }
  return (
    <>
      <Box sx={{ width: '70%', maxWidth: 190, opacity: 0.85 }}>
        <ImageCardGlyph title="New slide" />
      </Box>
      <UploadIcon sx={{ fontSize: 22, color: 'text.disabled' }} />
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        Drop an image or video, paste an image or video link, or click to add a slide
      </Typography>
    </>
  );
}
